/* eslint-disable no-console */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import axios from 'axios';

import Heading from '../shared/Heading';
import Checkbox from '../shared/Checkbox';

export default class UploadAd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFile: null,
      fileName: null,
      loaded: 0,
    };
  }

  handleSelectedFile = (e) => {
    const {
      setSignedUrl,
      modifyStep,
    } = this.props;

    this.setState({
      selectedFile: e.target.files[0],
      loaded: 0,
      fileName: e.target.files[0].name,
    }, () => {
      const { selectedFile } = this.state;
      /* eslint-disable-next-line */
      const data = new FormData();
      const endpoint = '/api/ad-upload';
      data.append('adfile', selectedFile, selectedFile.name);

      axios.post(endpoint, data, {
        // onUploadProgress: (ProgressEvent) => {
        //   const loaded = (ProgressEvent.loaded / ProgressEvent.total * 100);
        //   this.setState({
        //     loaded,
        //   });
        // },
      }).then((res) => {
        if (res.status === 200) {
          const { adId, signedUrl, fileFormat, html } = res.data;

          /* eslint-disable-next-line */
          const delayedDone = () => {
            const { loaded } = this.state;
            if (loaded < 100) {
              this.setState({ loaded: loaded + 1 });
              setTimeout(delayedDone, 0);
            } else {
              modifyStep({ valid: true });
              setSignedUrl(signedUrl, adId, fileFormat, html);
            }
          };

          delayedDone();
        }
      }).catch((err) => {
        console.log(err);
        alert(err.response.data.error.message);
      });
    });
  }

  onDragOver = (e) => {
    e.preventDefault();
  }

  onDropFile = (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (e.dataTransfer.items) {
      if (e.dataTransfer.items.length > 1) {
        /* eslint-disable-next-line */
        alert('Unable to process multiple files. Please upload one file at a time.');
      }

      const currentItem = e.dataTransfer.items[0];
      if (currentItem.kind === 'file') {
        const file = currentItem.getAsFile();
        this.handleSelectedFile({ target: { files: [file] } });
      } else {
        /* eslint-disable-next-line */
        alert(`Unrecognised file format ${currentItem.kind}`);
      }
    }
  }

  render() {
    const {
      loaded,
      fileName,
    } = this.state;

    /* eslint-disable-next-line */
    const buttonLoadTitle = loaded === 100
      ? 'UPLOAD A DIFFERENT FILE'
      : loaded === 0
        ? 'OR UPLOAD FILE'
        : '';

    const subText = loaded === 100
      ? fileName
      : 'HTML5 file size limit: 4MB';

    return (
      <div>
        <BorderedBox
          onDragOver={this.onDragOver}
          onDrop={this.onDropFile}
        >
          {loaded === 0 ? <Heading>Drop file here</Heading> : null}
          {loaded > 0 && loaded < 100 ? <Heading>Uploading... please wait</Heading> : null}
          {loaded === 100 ? <Heading>Upload successful</Heading> : null}
          <FileUpload type="file" name="adfile" id="file-upload" onChange={this.handleSelectedFile} />
          <UploadButton htmlFor="file-upload">
            <span style={{ position: 'absolute', zIndex: 1 }}>{buttonLoadTitle}</span>
            {loaded > 0 ? (
              <div
                style={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'white',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    width: `${loaded}%`,
                    height: '100%',
                    backgroundColor: '#7392ee',
                  }}
                />
              </div>
            ) : null}
          </UploadButton>
          <SubText>{subText}</SubText>
        </BorderedBox>

        <BorderedBox
          style={{
            height: 100,
            justifyContent: 'center',
            flexDirection: 'row',
          }}
        >
          <Checkbox label="File check 1" checked={loaded >= 20} />
          <Checkbox label="File check 2" checked={loaded >= 40} />
          <Checkbox label="File check 3" checked={loaded >= 60} />
          <Checkbox label="File check 4" checked={loaded >= 80} />
          <Checkbox label="File check 5" checked={loaded >= 100} />
        </BorderedBox>
      </div>
    );
  }
}

UploadAd.propTypes = {
  setSignedUrl: PropTypes.func.isRequired,
  modifyStep: PropTypes.func.isRequired,
};

const BorderedBox = styled.div`
  width: 100%;
  height: 350px;
  border: 2.5px solid #e2e5ef;
  border-radius: 3px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const UploadButton = styled.label`
  display: block;
  justify-content: flex-start;
  font-size: 15px;
  font-family: 'Karla', sans-serif;
  letter-spacing: 1.5px;
  border: 2.5px solid #7392ee;
  color: white;
  background-color: #7392ee;
  width: 250px;
  height: 50px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 35px;
  cursor: pointer;
`;

const FileUpload = styled.input`
  display: none;
`;

const SubText = styled.div`
  color: #505d68;
  font-size: 16px;
  letter-spacing: 0.5px;
  font-family: 'Karla', sans-serif;
  margin-top: 10px;
`;



// WEBPACK FOOTER //
// ./client/Upload/UploadAd.js